import { Tutorial } from '../tutorial.model';

export const CATEGORIA_CADASTRO_TOUR: Tutorial = {
  id: 'categoria-cadastro',
  rota: '/painel/categorias',
  dialogo: true,
  passos: [
    {
      alvo: 'categoria-cadastro.nome',
      fase: 'Nome, tipo e emissão',
      titulo: 'Identifique o uso desta categoria',
      corpo: 'Use um nome que facilite classificar e acompanhar as contas, como Serviços de consultoria. As categorias do modelo organizam as finanças, mas os dados fiscais do serviço precisam ser preenchidos para emitir notas.',
    },
    {
      alvo: 'categoria-cadastro.tipo',
      fase: 'Nome, tipo e emissão',
      titulo: 'Escolha onde a categoria será usada',
      corpo: 'Contas a pagar organiza despesas; Contas a receber organiza receitas e mostra a seção Fiscal. Se esta receita será faturada pelo sistema, prepare a tributação da categoria antes de usá-la nas primeiras contas.',
    },
    {
      alvo: 'categoria-cadastro.padrao',
      fase: 'Nome, tipo e emissão',
      titulo: 'Defina a categoria mais usada',
      corpo: 'Escolha Sim apenas se esta deve vir selecionada ao cadastrar contas a receber. Mesmo sendo padrão, confira se ela corresponde ao serviço de cada conta: a escolha também determina os códigos usados na nota.',
    },
    {
      alvo: 'categoria-cadastro.emissao',
      fase: 'Nome, tipo e emissão',
      titulo: 'Esta receita terá nota fiscal?',
      corpo: 'Escolha Sim para emitir notas das contas vinculadas a esta categoria e preencher os campos fiscais. Escolha Não para usá-la somente no controle financeiro; as ações de emissão ficam indisponíveis. Ao selecionar Sim, o guia continua nos campos de tributação.',
      corpoBase: 'Escolha Sim para emitir notas das contas vinculadas a esta categoria e preencher os campos fiscais. Escolha Não para usá-la somente no controle financeiro; as ações de emissão ficam indisponíveis. Ao selecionar Sim, aparecem os campos de tributação.',
    },
    {
      alvo: 'categoria-cadastro.tributacao',
      fase: 'Códigos do serviço',
      titulo: 'Código de tributação do serviço (ISSQN)',
      corpo: 'Escolha o serviço efetivamente prestado. No padrão nacional, o cTribNac tem seis dígitos: item e subitem da LC 116/2003 e desdobramento nacional. Por exemplo, 010101 identifica Análise e desenvolvimento de sistemas. Na emissão municipal, a lista segue a tabela da integração. Use uma nota anterior como referência e confirme com a contabilidade; a lista não valida as atividades do CNPJ.',
    },
    {
      alvo: 'categoria-cadastro.nbs',
      fase: 'Códigos do serviço',
      titulo: 'NBS: classificação do serviço',
      corpo: 'Selecione a NBS 2.0 do serviço, conforme o Anexo B. São nove dígitos: 1.1502.10.00 corresponde a 115021000. Pesquise pela descrição; NBS, CNAE e código de tributação têm tabelas próprias. O Anexo I exige NBS quando há informações de IBS/CBS na declaração e nas hipóteses de operações com o exterior. Confirme a classificação e sua aplicação com a contabilidade.',
    },
    {
      alvo: 'categoria-cadastro.municipal',
      fase: 'Códigos do serviço',
      titulo: 'Código de tributação municipal da prefeitura',
      corpo: 'O cTribMun tem três dígitos e identifica o desdobramento definido pelo município onde o ISSQN é devido. Nem todo município o adota. Cada opção reúne o código municipal e o nacional; confira a descrição e escolha a combinação do serviço. Resolva as pendências com a contabilidade antes de emitir. Se faltar a opção correta, procure o suporte com o município e o serviço.',
    },
    {
      alvo: 'categoria-cadastro.indicador',
      fase: 'IBS e CBS',
      titulo: 'Indicador da operação do IBS/CBS',
      corpo: 'Este bloco aparece quando a empresa está no regime IBS/CBS. Escolha o indicador da operação na lista oficial, conforme o serviço prestado. Use Nenhum quando a contabilidade não tiver definido o indicador. Uma opção antiga exibida como desabilitada precisa ser trocada antes de salvar.',
    },
    {
      alvo: 'categoria-cadastro.cst',
      fase: 'IBS e CBS',
      titulo: 'CST do IBS/CBS',
      corpo: 'Selecione o CST na lista oficial. Ao escolher um CST, a lista de classificações tributárias mostra apenas as que pertencem a ele, e a classificação que não combina com o CST é limpa.',
    },
    {
      alvo: 'categoria-cadastro.classificacao',
      fase: 'IBS e CBS',
      titulo: 'Classificação tributária do IBS/CBS',
      corpo: 'Selecione a classificação tributária na lista oficial. Ao escolher uma classificação, o CST é ajustado ao dela. Confirme a escolha com a contabilidade.',
    },
    {
      alvo: 'categoria-cadastro.credito',
      fase: 'IBS e CBS',
      titulo: 'Crédito presumido',
      corpo: 'Escolha o crédito presumido na lista oficial quando ele fizer parte da configuração indicada pela contabilidade. Use Nenhum quando não se aplicar.',
    },
    {
      alvo: 'categoria-cadastro.tributacao-iss',
      fase: 'Tributação ISSQN',
      titulo: 'Tributação ISSQN do serviço',
      corpo: 'Esta escolha vai nas notas desta categoria e vence a configuração fiscal da empresa. Com Não definido, vale a configuração da empresa; Operação tributável é uma escolha explícita. Na emissão, a tributação aparece já preenchida e pode ser trocada para a nota. Confirme a escolha com a contabilidade.',
    },
    {
      alvo: 'categoria-cadastro.tipo-imunidade',
      fase: 'Tributação ISSQN',
      titulo: 'Tipo de imunidade',
      corpo: 'Aparece com Tributação ISSQN Imunidade. O número no início de cada opção é o código enviado na nota. Confirme o tipo com a contabilidade.',
    },
    {
      alvo: 'categoria-cadastro.comercio-exterior',
      fase: 'Comércio exterior',
      titulo: 'Dados de comércio exterior',
      corpo: 'São usados nas notas para clientes no exterior, de exportação ou com prestação no exterior: modo de prestação, mecanismos de apoio da empresa e do cliente, movimentação temporária de bens e compartilhamento com o MDIC. O grupo abre sozinho com Exportação de serviço. Cada nota pode trocar esses dados na emissão.',
    },
    {
      alvo: 'categoria-cadastro.modo-prestacao',
      alvoAlternativo: 'categoria-cadastro.comercio-exterior',
      fase: 'Comércio exterior',
      titulo: 'Modo de prestação do serviço',
      corpo: 'Modo de prestação vai nas notas desta categoria que levam comércio exterior. O número no início de cada opção é o código enviado na nota. Na emissão, o campo vem com este valor e pode ser trocado. Confirme o modo com a contabilidade.',
    },
    {
      alvo: 'categoria-cadastro.mecanismo-empresa',
      alvoAlternativo: 'categoria-cadastro.comercio-exterior',
      fase: 'Comércio exterior',
      titulo: 'Mecanismo de apoio da sua empresa',
      corpo: 'Em Mecanismo de apoio ao comércio exterior da sua empresa, escolha o programa de apoio ou financiamento usado neste serviço, ou 01 - Nenhum. Confirme a escolha com a contabilidade.',
    },
    {
      alvo: 'categoria-cadastro.mecanismo-cliente',
      alvoAlternativo: 'categoria-cadastro.comercio-exterior',
      fase: 'Comércio exterior',
      titulo: 'Mecanismo de apoio do cliente',
      corpo: 'Em Mecanismo de apoio ao comércio exterior do cliente, escolha o programa de apoio que o cliente usa neste serviço, ou 01 - Nenhum. Confirme a escolha com a contabilidade.',
    },
    {
      alvo: 'categoria-cadastro.movimentacao-bens',
      alvoAlternativo: 'categoria-cadastro.comercio-exterior',
      fase: 'Comércio exterior',
      titulo: 'Movimentação temporária de bens',
      corpo: 'Em Movimentação temporária de bens, escolha 1 - Não ou o tipo de declaração ligada a este serviço. Com uma declaração, o número dela é informado na emissão de cada nota.',
    },
    {
      alvo: 'categoria-cadastro.mdic',
      alvoAlternativo: 'categoria-cadastro.comercio-exterior',
      fase: 'Comércio exterior',
      titulo: 'Compartilhamento com o MDIC',
      corpo: 'Em Compartilhar com o MDIC, escolha se as notas desta categoria ficam disponíveis ao Ministério do Desenvolvimento, Indústria, Comércio e Serviços. Na emissão, o campo vem com este valor e pode ser trocado.',
    },
    {
      alvo: 'categoria-cadastro.salvar',
      fase: 'Salvar a categoria',
      titulo: 'Deixe a categoria preparada para o uso',
      corpo: 'Confira nome, tipo e a escolha sobre emissão. Se escolheu Sim, revise o código do serviço, a NBS, o código municipal aplicável e, no regime IBS/CBS, os dados do IBS/CBS. Esses dados serão usados nas notas das contas vinculadas à categoria. Use Salvar para gravar; concluir o guia não salva nem autoriza a nota. A emissão também depende da configuração fiscal e do certificado da empresa.',
      corpoBase: 'Confira nome, tipo e a escolha sobre emissão. Se escolheu Sim, revise o código do serviço, a NBS, o código municipal aplicável e, no regime IBS/CBS, os dados do IBS/CBS. Esses dados serão usados nas notas das contas vinculadas à categoria. Use Salvar para gravar; salvar a categoria não autoriza a nota. A emissão também depende da configuração fiscal e do certificado da empresa.',
    },
  ],
};
